import {
  REPORT_ADD_USER_REQUEST,
  REPORT_ADD_USER_SUCCESS,
  REPORT_LOAD_FAILURE,
  REPORT_LOAD_REQUEST,
  REPORT_LOAD_SUCCESS,
  REPORT_REMOVE_USER_REQUEST,
  REPORT_REMOVE_USER_SUCCESS,
  REPORT_SET_SELECTED,
  REPORTS_LOAD_FAILURE,
  REPORTS_LOAD_REQUEST,
  REPORTS_LOAD_SUCCESS,
  TRegionsState,
  TReportsAction
} from '../types/reports-types';
import { TReport } from '../../../definitions';

export const initialState: TRegionsState = {
  loading: false,
  adding: false,
  removing: [],
  success: false,
  error: null,
  reports: [],
  report: null
};

export default function reportsReducer(
  state: TRegionsState = initialState,
  action: TReportsAction
): TRegionsState {
  switch (action.type) {
    case REPORTS_LOAD_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        error: null
      };

    case REPORTS_LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.error
      };

    case REPORTS_LOAD_SUCCESS:
      return {
        ...state,
        reports: action.payload as TReport[],
        loading: false,
        success: true,
        error: null
      };

    case REPORT_SET_SELECTED:
      return {
        ...state,
        report: state.reports.find((r) => r.id === (action.payload as string)) || null
      };

    case REPORT_LOAD_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        error: null
      };

    case REPORT_LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.error
      };

    case REPORT_LOAD_SUCCESS:
      return {
        ...state,
        report: action.payload as TReport,
        loading: false,
        success: true,
        error: null
      };

    case REPORT_ADD_USER_REQUEST:
      return {
        ...state,
        adding: true
      };

    case REPORT_ADD_USER_SUCCESS:
      return {
        ...state,
        adding: false
      };

    case REPORT_REMOVE_USER_REQUEST:
      return {
        ...state,
        removing: action.payload as string[]
      };

    case REPORT_REMOVE_USER_SUCCESS:
      return {
        ...state,
        removing: []
      };

    default:
      return state;
  }
}
